import React from "react";
import KuikaCloseButton, { KuikaCloseButtonSize } from "../../../../ui-kit/kuika-close-button/kuika-close-button";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";
import { VariantGrid } from "../_layout/variant-grid";

const SIZES: KuikaCloseButtonSize[] = ["md", "sm"];

export const CloseButtonStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Close button"
      componentName="KuikaCloseButton"
      sourcePath="ui-kit/kuika-close-button"
      description="The one dismiss control for modals, drawers, popovers, toasts and clear actions. The box stays small; the pointer target is always 32px, with the hover surface and the focus ring."
    >
      <VariantGrid
        label="size"
        cols={SIZES}
        cellMinWidth={120}
        render={(size: string): React.ReactNode => <KuikaCloseButton size={size as KuikaCloseButtonSize} />}
      />
      <SpecRow label="Custom label" caption='aria-label="Clear"'>
        <KuikaCloseButton size="sm" aria-label="Clear" />
      </SpecRow>
      <SpecRow label="Disabled" caption="disabled">
        <KuikaCloseButton disabled />
      </SpecRow>
    </ShowcaseFrame>
  );
};
